import { Component, OnInit,ViewChild, ɵConsole } from '@angular/core';
import swal from 'sweetalert2'; 
import { SelectItem } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import * as _ from 'underscore';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MenuItem} from 'primeng/api';
import * as fs from 'file-saver';
import { Workbook } from 'exceljs';
//import { DeprecatedI18NPipesModule } from '@angular/common';

import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';

import pdfMake  from 'pdfmake/build/pdfmake';

@Component({
  selector: 'app-frmentrenamiento',
  templateUrl: './frmentrenamiento.component.html',
  styleUrls: ['./frmentrenamiento.component.scss']
})
export class FrmentrenamientoComponent implements OnInit {

  loading: boolean = false;
  usu;

  bMat: boolean = false;
  cat; selcat;
  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  itmmat={
    id:0,
    codigo:""
  }

  itmselmat={
    id:0,
    codigo:""
  }

  bah; selbah;

  constructor(
    public authService: AuthService,
    public router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    //this.usu = this.authService.leerUsuario()    
    this.usu = 0
    if (this.usu != null){      
      this.ls_listadocategorias();
      this.ls_listadobahias();
    }else{
      this.router.navigate(['/login']);
    }
  }

  ls_listadocategorias(){
    var sqry;
    sqry = " select" +
            " id,nombre,color,estado " +
            " from tblcategoria_ent" + 
            " where estado <> 'C'" +
            " order by nombre";
    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                        
          if (res.length!=0)
          {
            var _cat = [];
            for(var i = 0; i < res.length;i++){
              var sestado = "Activo"
              if (res[i].estado == "B")
                sestado = "Desactivo";

              if ( res[i].estado!="C"){
                _cat.push({ 
                  id: res[i].id, 
                  nombre: res[i].nombre
                });
              }
            }
            this.cat = _cat;              
          }
          else
          {            
            //swal.fire('No existe información!', '', 'info');            
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });   
  }


  ls_listadobahias(){
    var sqry;    
    sqry = " select" +
           " id,nombre" +
           " from tblbahia" +
           " where estado <> 'C'" +           
           " order by nombre";

    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          if (res.length!=0)
          {
            var _bah = [];
            _bah.push({ id: 0, nombre: "-", });
            for(var i = 0; i < res.length;i++){
              _bah.push({ id: res[i].id, nombre: res[i].nombre, });
            }
            this.bah = _bah;   
            this.selbah = {id:0,nombre:"-"};
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }



  winnvo:boolean= false;
  ls_nvo(){
    this.itmmat.id = 0;
    this.itmmat.codigo = "";
    this.selbah = {id:0,nombre:"-"};
    this.winnvo = true;
  }

  cancelarnvo(){
    this.winnvo = false;
  }

  guardarnvo(){    
    if (this.itmmat.codigo == ""){
      swal.fire('', '<h3>Proporcione el código de la matriz</h3>', 'warning');
      return;
    }
    if (this.selbah.id == 0){
      swal.fire('', '<h3>Proporcione la bahía</h3>', 'warning');
      return;
    }

    this.loading = true;    
    var sqry;
    sqry = " call spins_tblencentrenamiento ('" + 
            this.itmmat.codigo + "'," +
            this.selbah.id + ")";
    this.authService.ejecuta(sqry).subscribe(
      data1 => {   
          this.loading = false;            
          var dat1 = JSON.stringify(data1);
          var res1 = JSON.parse(dat1);              
          
          //this.bInicia = false;                    
          this.itmselmat.id = res1[0][0].id;
          this.itmselmat.codigo = this.itmmat.codigo;

          this.ls_matriz();
          this.winnvo = false;

          //this.ls_llama("nvo");  
          //this.ls_matrices("");
          //this.bInicia = false;  
          //this.winedimat = false; 
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  mat;
  vest;
  vcur;
  ls_matriz(){
    var sqry;
    sqry = " select" +
          " tbldetentrenamiento.id," +
          " idestacion,tblestacion.nombre as estacion," +
          " idcurso,tblcurso.nombre as curso,`check`" +
          " from tbldetentrenamiento,tblestacion,tblcurso" +
          " where tbldetentrenamiento.idestacion = tblestacion.id" +
          " and tbldetentrenamiento.idcurso = tblcurso.id" +
          " and idencentrenamiento = " + this.itmselmat.id;
    this.loading = true;            
    this.authService.ejecuta(sqry).subscribe(
      data => {   
          this.loading = false;            
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0){
            var _mat = [];   
            for(var i = 0; i < res.length;i++){
              var check = false;
              if (res[i].check == 1){
                check = true;
              }
              _mat.push({ 
                id: res[i].id, 
                idestacion: res[i].idestacion, 
                estacion: res[i].estacion, 
                idcurso: res[i].idcurso,                                
                curso: res[i].curso,                                
                check: check,                                                                         
              }); 
            }
            this.mat = _mat;

            var _vest = _mat.reduce( (a,b) => {
              var i = a.findIndex( x => x.idestacion === b.idestacion);      
              return i === -1 ? a.push({ idestacion : b.idestacion,
                                          estacion : b.estacion,                                         
                                        }) : 0, a;
            }, []);  
            this.vest = _vest;

            var _vcur = _mat.reduce( (a,b) => {
              var i = a.findIndex( x => x.idcurso === b.idcurso);      
              return i === -1 ? a.push({ idcurso : b.idcurso,
                                          curso : b.curso,                                         
                                        }) : 0, a;
            }, []);  
            this.vcur = _vcur;
          }
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  toggleVisibility(eve,itm){
    var icheck = 0;
    if (eve.checked) icheck = 1;

    var sqry;
    sqry = " update tbldetentrenamiento set" +
            " `check` = " + icheck +
            " where id = " + itm.id;

    this.loading = true;            
    this.authService.ejecuta(sqry).subscribe(
      res => {        
      this.loading =  false;                                      
      this.ls_matriz();
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  abr;
  winabr= false;
  ls_abr(){

    var sqry;
    sqry = " select" +  
           " tblencentrenamiento.id,tblencentrenamiento.nombre as codigo,fecha" +
           " from tblencentrenamiento" +
           " where estado = 'A'" +
           " order by tblencentrenamiento.id desc";

    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          this.abr = data;
          this.winabr= true;          
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });   
  }

  ls_selmat(itm){
    this.itmselmat.id = itm.id;
    this.itmselmat.codigo = itm.codigo;
    this.ls_matriz();
    this.winabr = false;
  }

}
